import './new-status.scss';

import { useNavigate } from "react-router-dom";
import { zodResolver } from "@hookform/resolvers/zod";
import { FieldErrors, FormProvider, useForm } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";
import { Button } from "primereact/button";

import { MessageResponseDto } from "@api/api";
import { useFormApiMapper } from "@core/services/form-api-mapper.hook";
import { useQyCreateStatus } from "@core/query/status.query";
import { StatusFormRule, StatusFormSchema } from "@core/form/form.rule";
import { statusFormDefault } from "@core/form/form.default";
import { getFormErrorMessage } from "@core/utility/get-error-message";
import { useNotificationContext } from "@shared/ui/notification/notification.context";
import HeaderContent from "@shared/ui/header-content/header-content";
import FormStatus from "../form-status/form-status";

export function Status() {
  // LOCAL DECLARATION
  const navigate = useNavigate();
  const { mapCreateStatus } = useFormApiMapper();
  const { showError, showSuccess, showWarning } = useNotificationContext();

  // QUERIES
  const handleApiSuccess = (response: MessageResponseDto) => {
    const data = response.data as any;

    showSuccess(`New Status is created`);
    navigate(`../${data.code}`);
  };
  const { mutate: addStatus, isLoading: isCreating } =
    useQyCreateStatus(handleApiSuccess);

  // LOCAL FUNCTIONS
  const formMethod = useForm<StatusFormSchema>({
    defaultValues: statusFormDefault,
    resolver: zodResolver(StatusFormRule),
  });
  const { handleSubmit } = formMethod;

  const handleValidate = (form: StatusFormSchema) => {
    const formData = mapCreateStatus(form);
    addStatus(formData);
  };
  const handleValidateError = (err: FieldErrors<StatusFormSchema>) => {
    const formMessage = getFormErrorMessage(err);
    showError(formMessage);
  };

  return (
    <div id="Status" className="status">
      <HeaderContent
        title="New Status"
        backIcon={<FaChevronLeft />}
        onBack={() => navigate("../")}
      >
        <Button
          className="w-full block"
          label="Save"
          disabled={isCreating}
          onClick={handleSubmit(handleValidate, handleValidateError)}
        ></Button>
      </HeaderContent>

      <div className="p-7">
        <FormProvider {...formMethod}>
          <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4 bg-white">
            <FormStatus />
          </section>
        </FormProvider>
      </div>
    </div>
  );
}

export default Status;